var map = {
	"./audio.png": "d36e",
	"./compression.png": "4962",
	"./excel.png": "23b8",
	"./pdf.png": "9b6e",
	"./ppt.png": "b065",
	"./text.png": "bd18",
	"./unknown.png": "a693",
	"./video.png": "4dd8",
	"./word.png": "4c38"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d284";